module.exports = __webpack_public_path__ + "img/shirt-running.793f0ed2.svg";